import { SERVICE_URL } from './ServiceURL'

class VendaService {
  constructor (resource) {
    this.store = resource.$store
    this.http = resource.$http

    this.baseURL = `${SERVICE_URL}v1/proposta`
  }

  save (proposta) {
    return this.http.post(this.baseURL, proposta, {
      headers: {
        'x-access-token': this.store.state.user.token || ''
      }
    })
      .then(response => response.json())
      .catch(err => {
        return Promise.reject(err.message || err)
      })
  }

  update (proposta) {
    return this.http.put(`${this.baseURL}/${proposta.id}`, proposta, {
      headers: {
        'x-access-token': this.store.state.user.token || ''
      }
    })
      .then(response => response.json())
      .catch(err => {
        return Promise.reject(err.message || err)
      })
  }

  getPropostas (params) {
    return this.http.get(this.baseURL, {
      params,
      headers: {
        'x-access-token': this.store.state.user.token || ''
      }
    })
      .then(response => response.json())
      .catch(err => {
        return Promise.reject(err.message || err)
      })
  }
}

export default VendaService



// WEBPACK FOOTER //
// ./src/service/VendaService.js